export default () => ({
  component: 'networks-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
